import { type AxiosRequestConfig } from 'axios'

const logout = (): AxiosRequestConfig => {
  return {
    method: 'POST',
    url: '/auth/logout',
  }
}

export { logout }
